import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { Navigation } from './components/Navigation';
import { PropertyHero } from './components/PropertyHero';
import { PropertyOverview } from './components/PropertyOverview';
import { LocationHighlights } from './components/LocationHighlights';
import { Amenities } from './components/Amenities';
import { PropertyFooter } from './components/PropertyFooter';
import { GalleryPage } from './pages/GalleryPage';
import { LocationPage } from './pages/LocationPage';
import { BookingPage } from './pages/BookingPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { ContactPage } from './pages/ContactPage';
import { 
  cascaisConfig, 
  lisbonConfig, 
  sintraConfig, 
  obidosConfig, 
  tomarConfig, 
  evoraConfig, 
  nazareConfig, 
  penicheConfig 
} from './data/locationData';
import '@/App.css';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

const HomePage = () => {
  return (
    <>
      <PropertyHero />
      <PropertyOverview />
      <div id="location">
        <LocationHighlights />
      </div>
      <div id="amenities">
        <Amenities />
      </div>
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/sintra" element={<LocationPage config={sintraConfig} />} />
            <Route path="/cascais" element={<LocationPage config={cascaisConfig} />} />
            <Route path="/lisbon" element={<LocationPage config={lisbonConfig} />} />
            <Route path="/obidos" element={<LocationPage config={obidosConfig} />} />
            <Route path="/tomar" element={<LocationPage config={tomarConfig} />} />
            <Route path="/evora" element={<LocationPage config={evoraConfig} />} />
            <Route path="/nazare" element={<LocationPage config={nazareConfig} />} />
            <Route path="/peniche" element={<LocationPage config={penicheConfig} />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <PropertyFooter />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;